import Animated, { withTiming } from "react-native-reanimated";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS, PAGES_ROUTES, PAGES_TITLE } from "utils/Constants";
import { Image, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { Text, TouchableOpacity } from "react-native";
import { addToCart, setCart, updateCartProduct } from "appRedux/reducers/cartSlice";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useAnimatedStyle, useSharedValue } from "react-native-reanimated";
import { useEffect, useRef, useState } from "react";

import Accordion from "components/Accordion";
import Buttons from "components/Buttons";
import Carousel from "react-native-reanimated-carousel";
import { Images } from "assets";
import Pagination from "components/Pagination";
import ParentScrollView from "components/ParentScrollView";
import StepperButton from "components/PDP/StepperButton";
import { StyleSheet } from "react-native";
import VText from "components/VText";
import Heading from "components/Heading";
import Paragraph from "components/Pharagraph";

import { analytics } from "utils/firebaseConfig";
import { getClosetDigitisationData } from "appRedux/reducers/homeSlice";
import { logEvent } from "firebase/analytics";
import { Svg as svg } from "assets/svg";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

export default function ConciergeServices() {
    const maxQty = 10;

    const dispatch = useDispatch();
    const { closetDigitisationData } = useSelector((state) => state.HomeReducer);
    const cart = useSelector((state) => state.CartReducer.cart);
    const [isAddedToBad, setIsAddedToBad] = useState(false);
    const [addToBagLoading, setAddToBagLoading] = useState(false);
    const _checkoutPopUp = useSelector((state) => state.UtilsReducer._checkoutPopUp);
    const [loadingQtyChange, setLoadingQtyChange] = useState(false);

    const [selectedService, setSelectedService] = useState([
        {
            title: "Chat with Stylist",
            image: svg.chatIcon,
        },
        {
            title: "Send Recommendations",
            image: svg.recomadIcon,
        },
        {
            title: "Personalized Suggestions",
            image: svg.stylingIcon,
        },
        {
            title: "Organize Closet",
            image: svg.closetIcon,
        },
        {
            title: "Calendar Sync",
            image: svg.calanderIcon,
        },
    ]);
    const [selectedOption, setSelectedOption] = useState("Select your closet");
    const [showOptions, setShowOptions] = useState(false);
    const [productData, setProductData] = useState([]);
    const [qty, setQty] = useState(1);
    const _scrollRef = useRef();

    const [activeIndex, setActiveIndex] = useState(0);
    const _slider1Ref = useRef(null);
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(true);

    const carouselData = [
        { image: Images.gloveDigitilImage1 },
        { image: Images.gloveDigitilImage2 },
        { image: Images.gloveDigitilImage3 },
    ];

    const _renderItem = ({ item, index }) => {
        const isActive = activeIndex === index;
        return (
            <Image
                accessibilityLabel={`White Glove Digitization Image ${index + 1}`}
                source={item.image}
                style={{ width: "400", height: "100%", opacity: isActive ? 1 : 0.5 }}
                resizeMode="contain"
            ></Image>
        );
    };
    const rotate = useSharedValue(0);
    const rotate2 = useSharedValue(0);

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate.value}deg` }],
    }));
    const animatedStyles2 = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate2.value}deg` }],
    }));

    const onPressMinusBtn = () => {
        if (isAddedToBad && qty > 0) {
            setLoadingQtyChange(true);
            dispatch(
                updateCartProduct({
                    productId: selectedOption?.id,
                    quantity: qty - 1,
                })
            )
                .then((res) => {
                    setLoadingQtyChange(false);
                    if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
                        dispatch(setCart(res?.payload?.data));
                    }
                })
                .catch((err) => {
                    setLoadingQtyChange(false);
                });
        } else {
            setQty((prev) => {
                if (prev == 0) return 0;
                else return prev - 1;
            });
        }
    };

    const onPressPlusBtn = () => {
        if (isAddedToBad && qty > 0) {
            setLoadingQtyChange(true);
            dispatch(
                updateCartProduct({
                    productId: selectedOption?.id,
                    quantity: qty + 1,
                })
            )
                .then((res) => {
                    setLoadingQtyChange(false);
                    if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
                        dispatch(setCart(res?.payload?.data));
                    }
                })
                .catch((err) => {
                    setLoadingQtyChange(false);
                });
        } else {
            setQty((prev) => {
                if (prev == maxQty) return maxQty;
                else return prev + 1;
            });
        }
    };

    useEffect(() => {
        dispatch(getClosetDigitisationData());
    }, []);

    useEffect(() => {
        setProductData(closetDigitisationData?.products);
        // setSelectedOption(closetDigitisationData?.products[0]);
    }, [closetDigitisationData]);

    useEffect(() => {
        if (cart && cart?.cart && Array.isArray(cart?.cart) && cart?.cart?.length > 0 && selectedOption?.id) {
            let find = cart?.cart?.find((o) => selectedOption?.id == o?.product?.id);
            if (find) {
                setQty(find?.quantity);
                setIsAddedToBad(true);
            } else {
                setQty(1);
                setIsAddedToBad(false);
            }
        } else {
            setQty(1);
            setIsAddedToBad(false);
        }
    }, [cart, selectedOption]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setShowOptions(false);
                rotate2.value = 0;
            }
        };

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowOptions(false);
                rotate2.value = 0;
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <ParentScrollView>
            <View style={styles.container}>
                <View style={styles.contentContainer}>
                    <View style={styles.carouselView}>
                        <Carousel
                            loop
                            width={320}
                            height={500} // added 32 + extra for dynamic image height
                            ref={_slider1Ref}
                            autoPlay={true}
                            autoPlayInterval={2000}
                            data={carouselData}
                            onConfigurePanGesture={(PanGesture) => {}}
                            style={{ overflow: "visible" }}
                            mode="parallax"
                            modeConfig={{
                                parallaxScrollingScale: 1,
                                parallaxScrollingOffset: 100,
                                parallaxAdjacentItemScale: 0.75,
                            }}
                            scrollAnimationDuration={1000}
                            renderItem={_renderItem}
                            onSnapToItem={(index) => setActiveIndex(index)}
                            numberOfVisibleItems={3}
                        />
                        <Pagination
                            style={{
                                marginTop: spV(50),
                            }}
                            thickness={8}
                            backgroundColor="black"
                            data={Array.isArray(carouselData) ? carouselData : []}
                            selectedIndex={activeIndex}
                            containerStyle={{
                                width: "100px",
                                paddingVertical: 14,
                                alignItems: "center",
                                justifyContent: "center",
                                // backgroundColor:"red"
                            }}
                        />
                    </View>
                    <View style={styles.contentText}>
                        <Heading type="h1" style={styles.contentHeading}>Vêtir Concierge</Heading>
                        {selectedOption?.productPrice ? (
                            <VText style={styles?.productPrice}>
                                ${selectedOption?.productPrice?.toLocaleString()}
                            </VText>
                        ) : (
                            <VText style={styles?.productPrice}></VText>
                        )}

                        <View ref={dropdownRef} style={styles.selectContainer}>
                            <TouchableOpacity
                                onPress={() =>
                                    setShowOptions((prev) => {
                                        if (prev == true) {
                                            rotate2.value = 0;
                                            return false;
                                        } else {
                                            rotate2.value = 180;
                                            return true;
                                        }
                                    })
                                }
                                style={styles.dropdownButton}
                            >
                                <Heading type="h5" style={{ fontSize: fp(16), fontWeight: "350" }}>
                                    {selectedOption?.productName || "Select your closet"}
                                </Heading>

                                <Animated.View style={[animatedStyles2]}>
                                    <Svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <Path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                                            fill="#212427"
                                        />
                                    </Svg>
                                </Animated.View>
                            </TouchableOpacity>

                            {showOptions && (
                                <View style={styles.optionsContainer}>
                                    {productData.map((option, index) => (
                                        <TouchableOpacity
                                            onPress={() => {
                                                setSelectedOption(option);
                                                setShowOptions((prev) => {
                                                    rotate2.value = 0;
                                                    return false;
                                                });
                                            }}
                                            style={styles.pickerItem}
                                        >
                                            <Heading type="h5" style={{ fontSize: fp(16), fontWeight: "350" }}>
                                                {option.productName}
                                            </Heading>
                                        </TouchableOpacity>
                                    ))}
                                </View>
                            )}
                        </View>

                        <View style={styles.stepperContainer}>
                            <View style={styles.stepperButton}>
                                <StepperButton
                                    customStyle={{ height: "100%" }}
                                    itemCount={qty}
                                    MAX_CART_QTY={maxQty}
                                    onPressMinusBtn={onPressMinusBtn}
                                    onPressPlusBtn={onPressPlusBtn}
                                    loading={loadingQtyChange}
                                    isError={false}
                                />
                            </View>

                            <Buttons
                                text={isAddedToBad ? "Added To Bag" : "Add To Bag"}
                                disabled={!selectedOption?.id}
                                loading={addToBagLoading}
                                onPress={() => {
                                    if (qty > 0 && !isAddedToBad && !addToBagLoading) {
                                        setAddToBagLoading(true);
                                        dispatch(
                                            addToCart({
                                                productId: selectedOption?.id,
                                                qty: qty,
                                                size: "ONE SIZE",
                                            })
                                        )
                                            .then((res) => {
                                                setAddToBagLoading(false);
                                                if ([200]?.includes(res?.payload?.status) && res?.payload?.data?.cart) {
                                                    logEvent(analytics, FIREBASE_EVENT_NAMES.ADD_TO_CART, {
                                                        [FIREBASE_EVENT_PARAMS.PRODUCT_ID]: selectedOption?.id,
                                                    });
                                                    dispatch(setCart(res?.payload?.data));
                                                    _scrollRef?.current?.scrollTo({
                                                        x: 0,
                                                        y: 0,
                                                        animated: true,
                                                    });
                                                    const toShow = res?.payload?.data?.cart?.find((o) => {
                                                        if (o?.product?.id == selectedOption?.id) {
                                                            return true;
                                                        }
                                                    });
                                                    _checkoutPopUp?.current?.show([toShow], true);
                                                }
                                            })
                                            .catch((err) => {
                                                setAddToBagLoading(false);
                                                console.log("err", err);
                                                // alert("Error");
                                            });
                                    }
                                }}
                                containerStyle={{
                                    opacity:
                                        addToBagLoading || isAddedToBad || qty < 1
                                            ? 0.3
                                            : 1 && selectedOption?.id
                                            ? 1
                                            : 0.3,
                                    marginLeft: spH(12),
                                    width: "35%",
                                    height: hp(36),
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                textStyle={{
                                    fontWeight: "350",
                                }}
                            />
                        </View>
                        <TouchableOpacity
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottomWidth: 1,
                                borderColor: "rgba(33, 36, 39, 0.3)",
                                marginTop: spV(36),
                                zIndex: -99999,
                            }}
                            activeOpacity={0.8}
                            onPress={() => {
                                setIsOpen((prev) => {
                                    if (prev == true) {
                                        rotate.value = withTiming(0);
                                        return false;
                                    } else {
                                        rotate.value = withTiming(180);
                                        return true;
                                    }
                                });
                            }}
                        >
                            <VText
                                style={{
                                    fontSize: fp(16),
                                    lineHeight: "140%",
                                    fontWeight: "600",
                                    marginBottom: spV(10),
                                }}
                                text={"Description"}
                            />
                            <Animated.View style={animatedStyles}>
                                <Svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <Path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                                        fill="#212427"
                                    />
                                </Svg>
                            </Animated.View>
                        </TouchableOpacity>
                        <Accordion style={{ zIndex: -1 }} viewKey="qwerty" isExpanded={isOpen}>
                            <VText
                                style={{
                                    color: "rgba(33, 36, 39, 1)",
                                    marginBottom: 16,
                                    marginTop: 20,
                                    fontSize: fp(16),
                                    fontWeight: "350",
                                    lineHeight: "1.5",
                                }}
                            >
                            <Paragraph>
                                Step into the future of wardrobe management with our White Glove Concierge Digital
                                Closet Service. By appointment, our expert team will seamlessly transform your closet
                                into a smart, digital haven. Connect with us to schedule, and experience the convenience
                                of a digitized closet. To learn more, email us at Concierge@vetirapp.com or click to
                                purchase now and a member of our team will be in touch to schedule your custom
                                digitization.
                            </Paragraph>
                            </VText>
                        </Accordion>
                    </View>
                </View>
            </View>
        </ParentScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: spH(40),
        paddingVertical: spV(15),
        alignItems: "center",
    },
    heading: {
        fontSize: fp(32),
        fontFamily: "LibreBodoni",
        fontWeight: "350",
        color: "#212427",
    },
    carouselView: {
        width: wp(600),
        alignItems: "center",
        justifyContent: "center",
        marginRight: spH(80),
    },

    contentContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        // paddingHorizontal: spH(40),
    },

    contentHeading: {
        fontSize: fp(16),
        fontWeight: "650",
    },
    contentSubHeading: {
        fontSize: fp(16),
        fontWeight: "350",
        paddingVertical: spV(15),
    },
    contentText: {
        paddingVertical: spV(20),
        paddingLeft: spH(20),

        backgroundColor: "white",
    },

    button: {
        marginTop: spV(20),
    },
    buttonContainer: {
        marginTop: spV(20),
        width: wp(200),
        height: hp(36),
    },
    StylingServicesContainer: {
        paddingTop: spV(40),
        alignItems: "center",
    },

    StylingServices: {
        flexDirection: "row",
        justifyContent: "space-between",
        // paddingHorizontal: spH(40),
        paddingTop: spV(40),
        gap: wp(50),
    },
    StylingServicesHeading: {
        fontSize: fp(15),
        fontWeight: "600",
    },
    StylingServicesItem: {
        alignItems: "center",
    },
    StylingServicesImage: {
        width: fp(40),
        height: fp(40),
        marginBottom: spV(10),
    },
    StylingServicesText: {
        fontSize: fp(16),

        fontWeight: "450",
    },
    selectContainer: {
        marginTop: spV(20),
        width: wp(500),
    },
    pickerStyle: {
        borderWidth: 1,
        borderColor: "#2124274D",
    },
    pickerItem: {
        padding: spV(10),
        borderBottomWidth: 1,
        borderBottomColor: "#2124274D",
    },
    selectHeading: {
        fontSize: fp(16),
        fontWeight: "450",
        // marginBottom: spV(10),
    },
    dropdownButton: {
        borderWidth: 1,
        borderColor: "#2124274D",
        padding: spV(10),
        Width: wp(150),
        flexDirection: "row",
        justifyContent: "space-between",
    },
    optionsContainer: {
        width: "100%",
        marginTop: spV(10),
        top: hp(30),
        position: "absolute",
        zIndex: 99,
        backgroundColor: "white",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
        paddingHorizontal: spH(10),
        borderWidth: 1,
        borderColor: "#2124274D",
        // overflow: "scroll",
    },
    stepperButton: {
        // marginTop: spV(20),
        width: wp(110),
    },
    stepperContainer: {
        marginTop: spV(30),
        flexDirection: "row",
        justifyContent: "flex-start",
        gap: wp(20),
        zIndex: -99999,
    },
    productPrice: {
        fontSize: fp(16),
        fontWeight: "350",
        marginTop: spV(8),
    },
});
